import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" id=\"icon-arrow-right\"><defs><style>#icon-arrow-right .a{fill:#66a3ff;}</style></defs><path class=\"a\" d=\"M7,0l7,12H0Z\" transform=\"translate(12) rotate(90)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol